import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Pencil } from 'lucide-react';

import { ROUTES } from '#/config/routes';
import { Button } from '#/modules/commonComponents/button';
import { canEditStockReceipt } from '#/modules/imsMgmt/receipts/shared/receiptStatus';
import PurchaseOrderStockReceiptPreviewDialog from '#/modules/srmMgmt/purchaseOrder/components/PurchaseOrderStockReceiptPreviewDialog';

/**
 * 採購單入庫歷史列操作：預覽 Dialog＋DRAFT 編輯。
 */
const PurchaseOrderInboundPreviewCell = ({
  receiptId,
  receiptStatus,
  purchaseOrderId,
  onMutated,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const showEdit = canEditStockReceipt(receiptStatus) && Boolean(receiptId);

  if (!receiptId) {
    return <span className="text-muted-foreground">—</span>;
  }

  return (
    <div className="flex flex-wrap items-center justify-start gap-1.5">
      <Button type="button" size="sm" className="h-7" onClick={() => setPreviewOpen(true)}>
        預覽
      </Button>
      {showEdit ? (
        <Button type="button" size="sm" variant="outline" className="h-7" asChild>
          <Link to={ROUTES.stockReceiptEdit(receiptId)} aria-label="編輯入庫單">
            <Pencil className="size-3.5" aria-hidden />
            編輯
          </Link>
        </Button>
      ) : null}
      <PurchaseOrderStockReceiptPreviewDialog
        open={previewOpen}
        onOpenChange={setPreviewOpen}
        purchaseOrderId={purchaseOrderId}
        receiptId={receiptId}
        onMutated={onMutated}
      />
    </div>
  );
};

PurchaseOrderInboundPreviewCell.propTypes = {
  receiptId: PropTypes.string,
  receiptStatus: PropTypes.string,
  purchaseOrderId: PropTypes.string,
  onMutated: PropTypes.func,
};

export default PurchaseOrderInboundPreviewCell;
